module.exports = __webpack_public_path__ + "img/52002738_L.d3ac4105.png";